<div class="swiper-carousel-wrapper">
  <swiper #swiper slidesPerView="auto" [spaceBetween]="spaceBetween" [navigation]="false" [pagination]="false"
    [loop]="false" [watchOverflow]="true" (activeIndexChange)="onSwiperActiveIndexChange()"
    (lock)="onSwiperLock()" (unlock)="onSwiperUnlock()">
    <ng-container *ngFor="let video of videoUrls; let idx = index; trackBy: trackByFn">
      <ng-template swiperSlide>
        <div class="carousel-item cursor-pointer" (click)="!isDragging && openModal(video)"
          (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd(video)"
          (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp(video)">
          <div class="story">
            <!-- Camada externa com o gradiente -->
            <div class="gradient-border">
              <!-- Contêiner interno com a borda branca -->
              <div class="white-border">
                <video [poster]="video.thumbnail" class="item-video">
                  <source [src]="video.src" type="video/mp4">
                  Seu navegador não suporta a tag de vídeo.
                </video>
              </div>

            </div>
            <!-- <div class="py-1 px-2 text-base card border-none text-center shadow-none font-semibold">{{video.title}}
            </div> -->

          </div>
        </div>
      </ng-template>
    </ng-container>
  </swiper>
  <!-- ✅ Setas de navegação personalizadas — escondidas quando o Swiper está
       "locked" (watchOverflow: não há slides escondidos pra navegar) -->
  <ng-container *ngIf="!isSwiperLocked">
    <div class="swiper-nav-btn-prev" (click)="swiperInstanceCarousel?.slidePrev()">
      <button pButton icon="pi pi-chevron-left" class="circular-nav-button"></button>
    </div>

    <div class="swiper-nav-btn-next" (click)="swiperInstanceCarousel?.slideNext()">
      <button pButton icon="pi pi-chevron-right" class="circular-nav-button"></button>
    </div>
  </ng-container>
</div>

